import { useState, useEffect } from 'react';

const CONSENT_KEY = 'gdpr_consent';

export function useGDPRConsent() {
  const [hasConsent, setHasConsent] = useState<boolean>(false);
  const [isInitialized, setIsInitialized] = useState(false);

  // Initialize consent state from localStorage
  useEffect(() => {
    try {
      const stored = localStorage.getItem(CONSENT_KEY);
      setHasConsent(stored === 'true');
    } catch (error) {
      console.error('Error reading consent from localStorage:', error);
    } finally {
      setIsInitialized(true);
    }
  }, []);

  const setConsent = (value: boolean) => {
    try {
      localStorage.setItem(CONSENT_KEY, String(value));
      setHasConsent(value);
    } catch (error) {
      console.error('Error writing consent to localStorage:', error);
    }
  };

  return { hasConsent, setConsent, isInitialized };
}